module.exports = __webpack_public_path__ + "img/Logo_Governança_Empreendedora-branca.28a6b8dd.png";